import { render, staticRenderFns } from "./cusPayableList.vue?vue&type=template&id=5077f2d6&scoped=true&"
import script from "./cusPayableList.vue?vue&type=script&lang=js&"
export * from "./cusPayableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077f2d6",
  null
  
)

export default component.exports